import { LogEntry } from "@/model/interface/LogEntry";
import { useSocketSubscription } from "@/hooks/useSocketSubscription";

export function useLogStreamSocket(enabled: boolean, onLog: (entry: LogEntry) => void) {
  useSocketSubscription(enabled ? "/topic/platform-admin/logs" : null, (message) => {
    try {
      onLog(JSON.parse(message.body) as LogEntry);
    } catch {
      return;
    }
  });
}
